import { useQuery } from '@tanstack/react-query';
import { Archive } from 'lucide-react';
import { archivedCustomers } from '../lib/api';
import { useScope } from '../scope/scope';
import { Card } from '../ui/misc';

const day = (iso: string) => new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });

/**
 * Archived customers (WRMM-337), for owners covering every customer: hidden everywhere else, read-only, each with the day
 * its records are purged. There is no restore. Nothing shows until there is one.
 */
export function ArchivedCustomers() {
  const { mspId } = useScope();
  const archived = useQuery({ queryKey: ['scope', mspId, 'archived-customers'], queryFn: () => archivedCustomers(mspId) });
  if (!archived.data?.length) return null;
  return (
    <section aria-labelledby="archived-customers" className="space-y-2">
      <h2 id="archived-customers" className="flex items-center gap-2 text-[14px] font-semibold text-ink-2"><Archive className="size-4" />Archived customers</h2>
      <Card className="divide-y divide-line">
        {archived.data.map(c => (
          <div key={c.id} className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 px-4 py-3 text-[13.5px]">
            <span className="min-w-0 break-words font-medium">{c.name}</span>
            <span className="text-ink-3">Deleted {day(c.archivedAt)} · records purged {day(c.purgeAfter)}
              {c.falconCid && <> · CrowdStrike child <span className="font-mono text-[12.5px]">{c.falconCid}</span> still at CrowdStrike</>}</span>
          </div>
        ))}
      </Card>
    </section>
  );
}
